Vue.component('navigation', {
  template: templates.leaderBoardNavigation,
  data() {
    return {
      model: {
        page: 'single',
      }
    }
  },
  methods: {
    click(page) {
      const c = this;

      c.model.page = page;
      c.$root.$emit('showPage', page);
    }
  }
});

const vueApp = new Vue({
  el: '[data-view="viewer-dashboard"]',
  data() {
    return {
      model: {
        page: 'single'
      }
    }
  },
  mounted() {
    const c = this;

    c.$root.$on('showPage', page => {

      c.model.page = page;

    });
 
  },
  methods:{
    get(){

    }
}

});